function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/directional/vertical-align-bottom",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/directional/vertical-align-bottom (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/directional/vertical-align-bottom (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.125H.19a.189.189 0 0 1-.19-.188v-1.406a.189.189 0 0 1 .19-.187H16.5a.189.189 0 0 1 .19.187v1.406a.189.189 0 0 1-.19.188zm-8.156-4.311a.181.181 0 0 1-.082-.019.179.179 0 0 1-.066-.053L5.571 8.419a.187.187 0 0 1 .148-.3h1.732V.187A.187.187 0 0 1 7.638 0h1.406a.188.188 0 0 1 .188.187v7.932h1.737a.183.183 0 0 1 .168.1.186.186 0 0 1-.02.2l-2.625 3.323a.19.19 0 0 1-.066.053.184.184 0 0 1-.082.019z",
    transform: "translate(3.656 3.938)",
    style: {
      fill: "#current"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.296fe8b8be3a9443263fcf0b31cd5abc.svg";
export { ForwardRef as ReactComponent };